(function ($) {
    const year = $(".timeline-items-inner .item .year");
    const description = $(".timeline-items-inner .item .description");
    const itemsNumber = $(".timeline-items-inner .item").length;
    $(".timeline-items-inner").addClass(`year-items-${itemsNumber}`);


    year.on("mouseenter", function () {
        $(this).closest(".item").find(".dot-wrap").addClass("active");
    });

    year.on("mouseleave", function () {
        $(this).closest(".item").find(".dot-wrap").removeClass("active");
    });

    year.on("click", function () {
        const current = $(this).closest('.item').index();
        if ($(this).closest(".item").hasClass("current")) {
            $(this).closest(".item").removeClass("current");
            $(".text").slideUp("slow");
            description.slideUp("slow");
        } else {

            $(".timeline-items-inner .item").removeClass("current");
            $(this).closest(".item").addClass("current");
            description.slideUp( "slow" );
            $(".text").slideUp("slow");
            $('[data-target=' + current + ']').slideDown( "slow" );
            $(this).siblings(".description").slideDown( "slow" );
        }
    });

    $(".next-btn-wrap .cta-home__link").on("click", function (e) {
        e.preventDefault();
        const itemsNumber = $(".timeline-items-inner .item").length;
        const num = itemsNumber - 1;
        const current = $('.timeline-items-inner .item.current').index();
        let setCurrent;

        if (current === num) {
            setCurrent = 0;
            $(".timeline-items-inner .item").removeClass("current");
            description.slideUp( "slow" );
            $(".text").slideUp("slow");
            $('[data-item-id=' + setCurrent + ']').addClass("current");
            $('[data-item-id=' + setCurrent + ']').find(".description").slideDown( "slow" );
            $('[data-target=' + setCurrent + ']').slideDown( "slow" );
        } else {
            setCurrent = current + 1;
            $(".timeline-items-inner .item").removeClass("current");
            description.slideUp( "slow" );
            $(".text").slideUp("slow");
            $('[data-item-id=' + setCurrent + ']').addClass("current");
            $('[data-item-id=' + setCurrent + ']').find(".description").slideDown( "slow" );
            $('[data-target=' + setCurrent + ']').slideDown( "slow" );
        }
    })
})(jQuery);